export default __webpack_public_path__ + "static/TIMBERLINE-M-SERIES-28-O-nav-WEB-f8629948a1db58ca894181c2c99819af.png";